import { useTranslation } from "react-i18next";
import "./index.scss";
import { SvgIcon } from "../../SvgIcon";
import { Col, Form, Input, Row, InputNumber } from "antd";
import { IS_MOBILE } from "@/utils/tool";
import { useRef } from "react";
import sentry4Action from "@/utils/sentry";

type Props = {
  order: Order;
  form;
  className?: string;
};

/**
 * 拆分订单
 * @param props
 * @returns
 */
const SplitOrder = (props: Props) => {
  const { order, form, className } = props;
  const { t } = useTranslation();
  const inputNumberRef = useRef(null);
  return (
    <div
      className={`split-order-box ${IS_MOBILE ? "wrap" : "pc"} ${className || ""}`}
    >
      <Form
        form={form}
        name="dynamic_form_complex"
        autoComplete="off"
        requiredMark={false}
        initialValues={{ orders: [{}] }}
        labelAlign="left"
      >
        <div className="split-info">
          <div className="auth">
            <span className="email">{t("邮箱")}:</span>
            <span>
              {order.publishing_house_order_type === 4
                ? order.book_contact_email
                : order.contact_author_email}
            </span>
          </div>
          <Form.Item
            label={t("拆分金额")}
            className="form-item-line"
            name="money"
            // style={IS_MOBILE ? { marginBottom: 0 } : {}}
            rules={[
              { required: true, message: t("请输入订单金额") },
              {
                pattern: new RegExp(
                  /^(?!0(\.0{1,2})?$)([1-9]\d*|0)(\.\d{1,2})?$/
                ),
                message: t("输入的金额不正确"),
              },
            ]}
            wrapperCol={{ xs: 24 }}
          >
            <InputNumber
              className="money"
              placeholder={t("请输入订单金额")}
              addonBefore="¥"
              ref={inputNumberRef}
              variant="borderless"
              style={IS_MOBILE ? { width: "100%" } : {}}
            />
          </Form.Item>
        </div>
        <Form.List name="orders">
          {(fields, { add, remove }) => (
            <div
              style={{ display: "flex", rowGap: 16, flexDirection: "column" }}
              className="split-item-box"
            >
              {fields.map((field, index) => (
                <div className="split-item" key={index}>
                  <Row justify={"space-between"}>
                    <Col className="gutter-row" span={IS_MOBILE ? 24 : 12}>
                      <Form.Item
                        className="form-item-line"
                        label={t("联系人")}
                        name={[field.name, "apc_user_real_name"]}
                        rules={[
                          { required: true, message: t("请输入联系人姓名") },
                        ]}
                        wrapperCol={{ xs: 24 }}
                      >
                        <Input
                          variant="borderless"
                          className="real-name"
                          type="text"
                          placeholder={t("请输入联系人姓名")}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      className="gutter-row"
                      span={IS_MOBILE ? 24 : 12}
                      style={{ paddingLeft: IS_MOBILE ? "0" : "10px" }}
                    >
                      <Form.Item
                        className="form-item-line"
                        label={t("手机号")}
                        name={[field.name, "apc_user_mobile"]}
                        rules={[
                          { required: true, message: t("请输入手机号") },
                          {
                            pattern: new RegExp(/^[1|8]\d{10}$/i),
                            message: t("输入的手机号不正确"),
                          },
                        ]}
                        wrapperCol={{ xs: 24 }}
                      >
                        <Input
                          variant="borderless"
                          className="user-tell"
                          type="text"
                          placeholder={t("请输入联系人手机号")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify={"space-between"}>
                    <Col className="gutter-row" xs={24} lg={18}>
                      <Form.Item
                        className="form-item-line"
                        label={t("拆分金额")}
                        name={[field.name, "pay_money"]}
                        rules={[
                          { required: true, message: t("请输入订单金额") },
                          {
                            pattern: new RegExp(
                              /^(?!0(\.0{1,2})?$)([1-9]\d*|0)(\.\d{1,2})?$/
                            ),
                            message: t("输入的金额不正确"),
                          },
                        ]}
                        wrapperCol={{ xs: 24 }}
                        style={IS_MOBILE ? { marginBottom: 0 } : {}}
                      >
                        <InputNumber
                          variant="borderless"
                          className="money"
                          //   type="number"
                          placeholder={t("请输入订单金额")}
                          addonBefore="¥"
                          style={IS_MOBILE ? { width: "100%" } : {}}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      className="gutter-row"
                      //   lg={{ span: 6 }}
                      style={{ textAlign: "end" }}
                      //   xs={{ span: 24 }}
                      xs={24}
                      lg={6}
                    >
                      <div
                        className="del-box"
                        onClick={() => {
                          sentry4Action("拆分订单-删除", {});
                          remove(index);
                        }}
                      >
                        <SvgIcon icon="icon-shanchu" width={16} height={16} />
                        <span className="del-btn">{t("删除")}</span>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}

              <div
                className="add-order-box"
                onClick={() => {
                  sentry4Action("继续拆分", {});
                  add();
                }}
              >
                <SvgIcon
                  icon="icon-a-jiahaojianhao-xiao"
                  width={18}
                  height={18}
                />
                <span>{t("继续拆分")}</span>
              </div>
            </div>
          )}
        </Form.List>
      </Form>
    </div>
  );
};

export default SplitOrder;
